
(function () {
    'use strict';

    Directives.FileTypeTooltipDirective = function FileTypeTooltipDirective() {

        // @ngInject
        function FileTypeTooltipDirectiveControllerFunc($scope, $injector, $translate) {
            this.constructor.$super.call(this, $scope, $injector);
            this.__objectType = 'FileTypeTooltipDirectiveControllerFunc';
            this.$translate = $translate;

            this.fileType = [
                {
                    type: 'proposal',
                    icon: 'icon-hb-proposal',
                    title:'Proposal',
                    text: 'WORKSPACE.ACTIONS.LABELS.DESC._PROPOSAL_'
                },
                {
                    type: 'brochure',
                    icon: 'icon-hb-brochure',
                    title:'Brochure',
                    text: 'WORKSPACE.ACTIONS.LABELS.DESC._BROCHURE_'
                },
                {
                    type: 'brochure-new',
                    icon: 'icon-hb-brochure',
                    title:'The new brochure',
                    text: 'WORKSPACE.ACTIONS.LABELS.DESC._BROCHURE_NEW_'
                },
                {
                    type: 'invoice',
                    icon: 'icon-hb-invoice',
                    title:'Invoice',
                    text: 'WORKSPACE.ACTIONS.LABELS.DESC._INVOICE_'
                },
                {
                    type: 'agreement',
                    icon: 'icon-hb-agreement',
                    title:'Contract',
                    text: 'WORKSPACE.ACTIONS.LABELS.DESC._AGREEMENT_'
                },
                {
                    type: 'questionnaire',
                    icon: 'icon-hb-questionnaire',
                    title:'Questionnaire',
                    text: 'WORKSPACE.ACTIONS.LABELS.DESC._QUESTIONNAIRE_'
                },
                {
                    type: 'timeline',
                    icon: 'icon-hb-timeline',
                    title:'Timeline',
                    text: 'WORKSPACE.ACTIONS.LABELS.DESC._TIMELINE_'
                },
                {
                    type: 'attachment',
                    title: 'Upload',
                    text: 'WORKSPACE.ACTIONS.LABELS.DESC._ATTACHMENT_'
                }

            ];
        }

        var FileTypeTooltipDirectiveController = Class(Controllers.BaseController, {
            constructor: FileTypeTooltipDirectiveControllerFunc
        });

        return {
            scope: {
                type:'@',
                expanded: '=?',
                vendorType: '@'
            },
            templateUrl: 'angular/app/modules/core/features/workspace/file_type_tooltip/file_type_tooltip_directive_template.html',
            controller: FileTypeTooltipDirectiveController,
            controllerAs: 'fileTypeTooltipVm',
            bindToController: true
        };
    };
})();